import React from "react";
import TableRow from "./TableRow";
const AcreditacionesTable = ({
  selectedPeriodistas,
  setSelectedPeriodistas,
  periodistas,
  maxPreacreditados
}) => {
  return (
    <table className="acr-table">
      <thead>
        <tr>
          <th>Nombre y cargo</th>
          <th>dni</th>
          <th>Mail</th>
          <th>Nro. de celular</th>
          <th>estado</th>
        </tr>
      </thead>
      <tbody>
        {periodistas.map((per, i) => (
          <TableRow
            periodista={per}
            selectedPeriodistas={selectedPeriodistas}
            setSelectedPeriodistas={setSelectedPeriodistas}
            maxPreacreditados={maxPreacreditados}
            key={i}
          />
        ))}
      </tbody>
    </table>
  );
};

export default AcreditacionesTable;
